import { useToast } from '@app/core/notifications';
import { pushTo } from '@app/core/routing';
import { auditReports } from '@mi-front/api-clients';
import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  reportType: string;
}

export function CreateButton({ reportType }: Props) {
  const { $t } = useIntl();
  const { notifyError } = useToast();
  const queryClient = useQueryClient();

  const createMutation = auditReports.useCreateReportDefinition({
    mutation: {
      onSuccess: async (createdDefinition) => {
        await queryClient.invalidateQueries({
          queryKey: auditReports.listReportDefinitionQueryKey({
            reportType,
          }),
        });
        pushTo(`/audit/config/report-definitions/by-id/${createdDefinition.id}`);
      },
      onError: (error) => {
        notifyError(
          $t({
            id: 'audit.reportDefinitions.createError',
            defaultMessage: 'Error al crear la plantilla',
          }),
        );
        console.error(error);
      },
    },
  });

  const handleCreate = () => {
    createMutation.mutate({ reportType });
  };

  return (
    <Button
      onClick={handleCreate}
      loading={createMutation.isPending}
      variant="contained"
      color="primary"
      size="small"
      startIcon={<Add />}
    >
      <FormattedMessage
        id="audit.reportDefinitions.newTemplateButton"
        defaultMessage="Nueva plantilla"
      />
    </Button>
  );
}
